// @flow

import { createStore } from "redux";

import combinedReducers from "./combinedReducers";

// Create store from combined reducers (from all 3 apps)
const store = createStore(
  combinedReducers,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js